import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=188cbaed&scoped=true&lang=pug&"
var script = {}
import style0 from "./Version.vue?vue&type=style&index=0&id=188cbaed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188cbaed",
  null
  
)

export default component.exports